import { Map as ImmMap } from 'immutable';
import {
	SET_APP_INDIVIDUAL,
	SET_APP_JOINT,
	APP_TYPE_INDIVIDUAL,
	APP_TYPE_CUSTOMER_JOINT,
	SET_RETURNED_FROM_THIRD_PARTY_SITE,
	SET_PROVIDER_ID,
	SET_RECEIVED_PROVIDER_TO_USE_FROM_STORIS,
	SET_STORE_NAME,
	SET_DEFAULT_PROVIDER,
	SET_USER_CONSENTED,
	SET_ADDITIONAL_PROVIDER_REVIEW_CHECKBOX_DISPLAYED,
	SET_CFA_TRACE_ID
} from './constants';

export const initialState = new ImmMap({
	applicantIndicator: APP_TYPE_INDIVIDUAL,
	receivedProviderToUseFromSTORIS: false,
	providerId: '',
	receivedStoreName: '',
	defaultProvider: '',
	userConsented: false,
	additionalProviderReviewCheckboxDisplayed: false,
	cfaTraceId: '',
});

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SET_APP_INDIVIDUAL: {
			return state.set('applicantIndicator', APP_TYPE_INDIVIDUAL);
		}
		case SET_APP_JOINT: {
			return state.set('applicantIndicator', APP_TYPE_CUSTOMER_JOINT);
		}
		case SET_RETURNED_FROM_THIRD_PARTY_SITE: {
			return state.merge({
				returnedFromThirdPartySite: true,
			});
		}
		case SET_PROVIDER_ID: {
			return state.set('providerId', action.providerId);
		}
		case SET_RECEIVED_PROVIDER_TO_USE_FROM_STORIS: {
			return state.set('receivedProviderToUseFromSTORIS', action.receivedProviderToUseFromSTORIS);
		}
		case SET_STORE_NAME: {
			return state.set('storeName', action.storeName);
		}
		case SET_DEFAULT_PROVIDER: {
			return state.set('defaultProvider', action.defaultProvider);
		}
		case SET_USER_CONSENTED: {
			return state.set('userConsented', action.userConsented);
		}
		case SET_ADDITIONAL_PROVIDER_REVIEW_CHECKBOX_DISPLAYED: {
			return state.set(
				'additionalProviderReviewCheckboxDisplayed',
				action.additionalProviderReviewCheckboxDisplayed,
			);
		}
		case SET_CFA_TRACE_ID: {
			return state.set(
				'cfaTraceId', action.cfaTraceId);
		}
		default:
			return state;
	}
};

export default reducer;
